import CategoryManager from './category-manager';

export default CategoryManager;